
import { apiSlice } from "./apiSlice";

export const satchelApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['ARAMEX-SATCHEL'] })
    .injectEndpoints({
        keepUnusedDataFor: 1,
        endpoints: builder => ({
            getSatchels: builder.query({
                query: (params) => ({
                    url: `/oto/order/satchels`,
                    method: 'GET',
                    params
                }),
                providesTags: [{ type: "ARAMEX-SATCHEL", id: "ARAMEX-SATCHEL-PARTIAL-LIST" }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getSatchelsByAdmin: builder.query({
                query: (params) => ({
                    url: `/oto/order/satchels/admin`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            requestSatchels: builder.mutation({
                query: (payload) => ({
                    url: `/shipment/satchel`,
                    method: 'POST',
                    body: { ...payload }
                }),
                invalidatesTags: [{ type: "ARAMEX-SATCHEL", id: "ARAMEX-SATCHEL-PARTIAL-LIST" }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getSatchelsRequestsCount: builder.query({
                query: () => ({
                    url: `/oto/order/satchels/count`,
                    method: 'GET',
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
              getControlSatchelsShipmentAdmin: builder.query({
                query: () => ({
                    url: `/oto/order/satchels/availability`,
                    method: 'GET',
                }),
                invalidatesTags: [{ type: "ARAMEX-SATCHEL", id: "ARAMEX-SATCHEL-PARTIAL-LIST" }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetSatchelsQuery,
    useRequestSatchelsMutation,
    useGetSatchelsRequestsCountQuery,
    useGetSatchelsByAdminQuery,
    useGetControlSatchelsShipmentAdminQuery
} = satchelApi
